export const normalizeReferralCode = (value: string): string => value.trim().toUpperCase();
